module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/confirm/confirm.component.scss
// module id = ./src/app/shared/confirm/confirm.component.scss
// module chunks = main